import { Directive, Input, TemplateRef } from '@angular/core';
import { TableWrapperHeader } from '@client/app/shared-modules/table/components/table-wrapper.component';

@Directive({
    selector: '[monTableCellTemplate]',
    standalone: true,
})
export class TableCellTemplateDirective<T> {
    @Input('monTableCellTemplate') header!: TableWrapperHeader<T>;

    constructor (public template: TemplateRef<{ $implicit: T; index: number }>) {}

    static ngTemplateContextGuard<T> (
        dir: TableCellTemplateDirective<T>,
        ctx: unknown,
    ): ctx is { $implicit: T; index: number } {
        return true;
    }
}
